import { OptionsIcon } from "assets/icons/OptionsIcon";
import {
  showErrorToast,
  showSuccessToast,
} from "components/CustomAlerts/CustomToast";
import { ModalConfirm } from "components/ModalConfirm/ModalConfirm";
import { CajaCurricularI } from "interfaces/CajaCurricular";
import { Dropdown } from "react-bootstrap";
import { deleteCajaCurricular } from "services/cajaCurricular";

interface Props {
  elemento: CajaCurricularI;
  onClickEdit: (elemento: CajaCurricularI) => void;
  onClickVerDetalle: (elemento: CajaCurricularI) => void;
  refreshTable: () => void;
}

export const CajasCurricularesRowActions = ({
  elemento,
  onClickEdit,
  onClickVerDetalle,
  refreshTable,
}: Props) => {
  const handleDelete = async (id: string | number) => {
    try {
      await deleteCajaCurricular(id);
      showSuccessToast("¡La caja curricular fue eliminada con éxito!");
      refreshTable();
    } catch (error) {
      showErrorToast("Error eliminando la caja curricular");
    }
  };

  // const onClickVerDocumento = (id: string | number) => {
  //     openFile({ id })
  // }

  return (
    <Dropdown className="acciones-dropdown | d-flex justify-content-center">
      <Dropdown.Toggle>
        <OptionsIcon />
      </Dropdown.Toggle>

      <Dropdown.Menu>
        <Dropdown.Item onClick={() => onClickVerDetalle(elemento)}>
          Ver detalle
        </Dropdown.Item>

        <Dropdown.Item onClick={() => onClickEdit(elemento)}>
          Editar
        </Dropdown.Item>

        <ModalConfirm
          title="Eliminar caja curricular"
          onConfirm={() => handleDelete(elemento.id)}
          message={
            <p>
              Estas por eliminar la Caja curricular {elemento.nombre} <br />
              <b>¿Querés realizar esta acción? Esta acción es irreversible.</b>
            </p>
          }
          renderButton={(handleShow: () => void) => (
            <Dropdown.Item onClick={handleShow}>Eliminar</Dropdown.Item>
          )}
        />
      </Dropdown.Menu>
    </Dropdown>
  );
};
